import * as React from 'react';
import { useEffect, useRef } from "react";

export const useClickOutsideRef = <T extends HTMLElement = HTMLElement>(
    callback: (e: MouseEvent | TouchEvent) => void
) => {
    const ref = useRef<T>(null);

    useEffect(() => {
        const handler = (e: MouseEvent | TouchEvent) => {
            const node = ref?.current;

            // if the mouse click occurred outside of this component, then let the component know it lost focus
            if (node && !node.contains(e.target as Node)) {
                callback(e);
            }

            return false;
        };

        // listen for mouse clicks on the page
        document.addEventListener("mousedown", handler);

        return () => {
            // clean up the listener
            document.removeEventListener("mousedown", handler);
        };
    });

    return ref;
};